module.exports = __webpack_public_path__ + "static/media/keno.94f326d6.png";